/* eslint-disable react/no-danger */
import React, { useState, useEffect, useMemo } from 'react';
import jumpToSpaceIcon from '../../atoms/customIcons/jumptoSpace.png';
import './spacesMap.scss';
import noImage from '../../atoms/customIcons/XtadiumRoomPosterXSNoImage.png';
import minusIcon from '../../atoms/customIcons/minus_icon.svg';
import plusIcon from '../../atoms/customIcons/plus_icon.svg';
import Icon, { IconType, IconSize } from '../../atoms/icon/icon';
const SpacesMap = (props) => {
  const {
     value
  } = props;
  const [data,setData]=useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
     setData(value || []);
  }, [value]);

  const issues = useMemo(() => {
    if (!value) return [];
    if (Array.isArray(value)) return value?.[0]?.issues || [];
    return value?.issues || value?.spacesMap?.[0]?.issues || [];
  }, [value]);

  const hasIssues = issues.length > 0;

  useEffect(() => {
    setDismissed(false);
  }, [issues]);

  function MapNode({ node }) {
     const [collapsed, setCollapsed] = useState(false);
     const hasChildren = node.children && node.children.length > 0;

     return (
     <li>
          <div
          className="item" style={{ cursor: hasChildren ? "pointer" : "default" }} onClick={(e) => {
               // prevent toggling when clicking jump icon
               if (!e.target.closest(".jump")) {
                    hasChildren && setCollapsed(!collapsed);
          }
        }}
      >
          {hasChildren && (
          <span className="toggle">{collapsed ? <img src={plusIcon}/> : <img src={minusIcon}/>}</span>
        )}
        {!hasChildren && <span className="no-toggle"></span>}
        <div className="icon-block">
          <img className="icon" src={node.logo?node.logo:noImage} alt="" />
        </div>
        <div className="info-block">
          {node.entryPoint && <div className="entry-point-block"><div>ENTRY POINT</div></div>}
          <div className="space-block">
            <div className="space-title">Space name:</div>
            <div className="space-name">{node.label}</div>
          </div>
        </div>
        
        
        <div className="jump">
          <a className="icon-link" href={node.link} >
          <img src={jumpToSpaceIcon} alt="jump" /></a>
        </div>
      </div>

      {hasChildren && !collapsed && (
        <ul>
          {node.children.map((child, idx) => (
            <MapNode key={idx} node={child} />
          ))}
        </ul>
      )}
    </li>
  );
}
  return (
    <div className="spaces-map-wrapper">
      {hasIssues && !dismissed && (
        <div className="spaces-map-warning" role="alert">
          <div className="spaces-map-warning__header">
            <div className="spaces-map-warning__left">
              <Icon
                icon={IconType.ALERT}
                iconSize={IconSize.SMALL}
                iconColor="#b7791f"
              />
              <strong>Configuration issue</strong>
            </div>

            <div
              className="spaces-map-warning__close"
              onClick={() => setDismissed(true)}
              role="button"
            >
              <Icon icon={IconType.CLOSE} iconSize={IconSize.SMALL} />
            </div>
          </div>

          <div className="spaces-map-warning__text">
            The entrypoint canvas references {issues.length} missing/misconfigured space(s).
            Please review the entrypoint canvas configuration.
          </div>
        </div>
      )}

      <ul className="map -stacked">
      {data.map((node, idx) => (
        <MapNode key={idx} node={node} />
      ))}
    </ul>
    </div>
  );
};


export default SpacesMap;
